<template>
  <div class="row">
    <div
      v-for="type in types"
      :key="type.id"
      class="col-xs-12 col-sm-4">
      <div class="box p-a">
        <transition
          name="fade"
          mode="out-in">
          <div
            key="content"
            class="content">
            <div class="pull-left m-r">
              <span :class="type.class">
                <i
                  class="material-icons"
                  v-html="type.icon"/>
              </span>
            </div>
            <div class="clear">
              <span>
                <h4 class="m-a-0 text-lg _300">
                  <span v-if="!loading">
                    RM {{ type.total }}
                  </span>
                  <small
                    v-show="loading"
                    class="text-xs"><i class="fa fa-spinner fa-spin fa-2x"/></small>
                </h4>
              </span>
              <small class="text-muted">{{ type.name }}</small>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Laravel from '../../laroute';

export default {
    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        return {
            loading: true,
            types: [
                {
                    id: 'voided_receipts',
                    name: 'Total Voided Receipts',
                    total: null,
                    class: 'w-48 rounded primary',
                    icon: '&#xE25C;',
                },
                {
                    id: 'returned_items',
                    name: 'Total Returned Items',
                    total: null,
                    class: 'w-48 rounded accent',
                    icon: '&#xe15c;',
                },
                {
                    id: 'aborted_fuel',
                    name: 'Total Aborted Fuel',
                    total: null,
                    class: 'w-48 rounded warn',
                    icon: '&#xe561;',
                },
            ],
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laravel.route('franchise.report.voidedsales.getSummary', {
                id: this.outlet,
            });
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        outlet() {
            this.getSumTransaction();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.getSumTransaction();
        },

        filters: function(to, from) {
            if (to === from) return;
            this.getSumTransaction();
        },
    },

    mounted() {
        this.getSumTransaction();
    },

    methods: {
        getSumTransaction() {
            this.loading = true;

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                filters: this.filters,
            };

            this.$http.get(this.api, { params: options }).then(response => {
                var data = response.data.data;
                this.types = this.types.map(obj => {
                    obj.total = data[obj.id];
                    return obj;
                });

                this.loading = false;
            });
        },

        formatNumber(number) {
            return numeral(number).format('0,0');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/boxSummary.vue